import React from 'react';
import PropTypes from 'prop-types';
import { StyledComponent } from 'styled-components';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

import { LinkFooterSection, LinkFooterSectionSecondary, IconFooterSection } from './Footer.styles';

const sectionMapping: { [key: string]: StyledComponent<'div', BabbelTheme> } = {
  primary: LinkFooterSection,
  secondary: LinkFooterSectionSecondary,
  icon: IconFooterSection,
};

export type FooterSectionProps = {
  children: React.ReactNode;
  /**
   * Name of the footer section coming from footer-content.lib
   */
  sectionName: string;
};

export const FooterSection = ({
  sectionName,
  children,
  ...otherProps // other DIV props, e.g. data attributes
}: FooterSectionProps): JSX.Element => {
  const Section = sectionMapping[sectionName];

  return <Section {...otherProps}>{children}</Section>;
};

FooterSection.propTypes = {
  sectionName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
